import {
  CircularProgress,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import SimpleAlert from "../../../../components/display/SimpleAlert";
import { useGetCategoreisOverAppointment } from "../../../../components/form/fileUpload/hooks/useGetCategoreis";
import { fileControlField } from "../../../../components/form/FileUploadBody";

export default function EditFiles() {
  const methods = useFormContext();
  const selectedFiles = methods.watch(fileControlField) || [];
  const { errors } = methods.formState;

  if (selectedFiles.length < 1) {
    return <SimpleAlert severity={"info"} message={"NoFilesToEdit"} />;
  }
  if (selectedFiles.length < 1) {
    return <SimpleAlert severity={"info"} message={"NoFilesToEdit"} />;
  }

  return (
    <>
      {selectedFiles.map((file, index) => (
        <Stack
          m={1}
          spacing={1}
          justifyContent={"space-between"}
          direction={"row"}
          alignItems={"center"}
        >
          <Typography>{index + 1}</Typography>
          {/* Title Field */}
          <Controller
            name={`files[${index}].title`}
            control={methods.control}
            defaultValue={file?.name || ""}
            render={({ field }) => (
              <TextField
                {...field}
                label={file?.name}
                fullWidth
                inputProps={{ maxLength: 119 }}
                error={!!errors?.files?.[index]?.title}
                helperText={errors?.files?.[index]?.title?.message || ""}
              />
            )}
          />
          <CategoryPicker index={index} />
        </Stack>
      ))}
    </>
  );
}

function CategoryPicker({ index }) {
  const { t } = useTranslation();
  const { id: appointmentId } = useParams();
  const categories = useGetCategoreisOverAppointment(appointmentId);
  const methods = useFormContext();
  const { errors } = methods.formState;

  if (categories.isLoading) {
    return <CircularProgress />;
  } else if (categories?.error) {
    return (
      <SimpleAlert
        severity={"error"}
        message={"FailedToFetchDocumentCategoryList"}
      />
    );
  } else if (categories.translatedCategories.length == 0) {
    return null;
  }

  return (
    <Controller
      name={`files[${index}].category`}
      control={methods.control}
      defaultValue=""
      render={({ field }) => (
        <FormControl fullWidth error={!!errors?.files?.[index]?.category}>
          <InputLabel>{t("Category")}</InputLabel>
          <Select {...field} label={t("Category")}>
            {categories?.translatedCategories?.map((category) => (
              <MenuItem value={category?.id} key={category?.id}>
                {category?.title}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>
            {errors?.files?.[index]?.category?.message || ""}
          </FormHelperText>
        </FormControl>
      )}
    />
  );
}
